<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    bottom
    offset-y
    left
    max-width="420"
    min-width="360"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        class="mr-1"
        v-bind="attrs"
        v-on="on"
        :title="$t('solicitacoesRelatorios.menuTitle')"
      >
        <v-icon :color="colorInfo">mdi-file-download-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="subtitle-1 py-3">
        {{ $t('solicitacoesRelatorios.menuTitle') }}
        <v-spacer />
        <v-btn icon small :loading="loading" @click="fetchItems">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <SolicitacoesRelatoriosList
        dense
        :items="items"
        :loading="loading"
        style="max-height: 360px; overflow-y: auto;"
      />
      <v-divider />
      <v-card-actions>
        <v-btn
          text
          small
          color="primary"
          :to="{ name: 'SolicitacoesRelatorios' }"
          @click="menuOpen = false"
        >
          {{ $t('solicitacoesRelatorios.viewAll') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import SolicitacoesRelatoriosList from '@/components/SolicitacoesRelatoriosList.vue';

export default {
  name: 'SolicitacoesRelatoriosMenu',
  components: { SolicitacoesRelatoriosList },
  props: {
    colorInfo: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      menuOpen: false,
      loading: false,
      items: [],
    };
  },
  watch: {
    menuOpen(open) {
      if (open) {
        this.fetchItems();
      }
    },
  },
  mounted() {
    EventBus.$on('scheduler-download-enqueued', this.fetchItems);
    EventBus.$on('system-log-export-updated', this.fetchItems);
    EventBus.$on('scheduler-download-updated', this.fetchItems);
  },
  beforeDestroy() {
    EventBus.$off('scheduler-download-enqueued', this.fetchItems);
    EventBus.$off('system-log-export-updated', this.fetchItems);
    EventBus.$off('scheduler-download-updated', this.fetchItems);
  },
  methods: {
    fetchItems() {
      this.loading = true;
      apiController.request(apiController.endpoints.schedulerGetSolicitacoesrelatorios, {
        data: { limit: 10 },
        silent: true,
        onSuccess: (response) => {
          this.items = (response.data && response.data.solicitacoes) || [];
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
  },
};
</script>
